import { render } from "./Project.vue?vue&type=template&id=19fbed7c&scoped=true&ts=true"
import script from "./Project.vue?vue&type=script&lang=ts"
export * from "./Project.vue?vue&type=script&lang=ts"

import "./Project.vue?vue&type=style&index=0&id=19fbed7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19fbed7c"]])

export default __exports__